import StyledButton from "ae-base/Base/StyledButton";
import Style from "ae-style";
import React from "react";
import { View, Platform } from "react-native";
import ResponsiveStylesheet from "react-native-responsive-stylesheet";

import { useResources } from "@aetonix/hooks";

const styles = ResponsiveStylesheet.createSized("min-direction", {
	0: {
		actions: {
			flexDirection: "row",
			justifyContent: "flex-end",
			marginTop: 0,
			marginBottom: Style.layout.marginSmall
		},
		cancel: {
			marginLeft: Style.layout.marginSmall
		},
		cancelSmall: {
			marginRight: 20,
			marginLeft: Style.layout.marginSmall,
			maxWidth: "70%",
		}
	},
	512: {
		actions: {
			flexDirection: "row",
			justifyContent: "flex-end",
			marginTop: Style.layout.marginContentVertical,
			marginBottom: 0
		}
	}
});

export default function SubmitActions(props) {
	const { localize } = useResources();
	const onSubmit = props.onSubmit;
	const onCancel = props.onCancel;
	const submitText = props.submitText || localize("common.save");
	const submitStyle = props.submitStyle;
	const textStyle = props.textStyle;
	const cancelText = props.cancelText;
	const submitting = props.submitting;
	const errors = props.errors;
	const disableSubmit = (errors && errors.length) || submitting;
	const id_prefix = props.id_prefix;

	const cancelButtonStyle = cancelText && cancelText.length > 17 && Platform.OS !== "web" ? styles.cancelSmall : styles.cancel;

	const cancelButton = cancelText ? (
		<View style={cancelButtonStyle}>
			<StyledButton id={id_prefix + "cancel"} alert title={cancelText} textStyle={textStyle} icon="delete" onPress={onCancel} />
		</View>
	) : null;
	return (
		<View style={[styles.actions, submitStyle]}>
			<View>
				<StyledButton
					contrast
					title={submitText}
					id={id_prefix + "submit"}
					icon="check"
					onPress={onSubmit}
					disabled={disableSubmit}
					textStyle={textStyle}
					delayClicks
				/>
			</View>
			{cancelButton}
		</View>
	);
}